module.exports = __webpack_public_path__ + "static/media/20200907_H_Solution 2.ee351d81.svg";